import React from 'react';
import PropTypes from 'prop-types';

/**
 * React 19: uses <Activity />
 * React 18: renders conditionally (or keeps mounted)
 */
export function ActivityCompat({ active, children }) {
   // We use display: contents so the wrapper div is transparent to the layout (Flex/Grid)
   // We use display: none when inactive to hide the app without unmounting its lifecycle.
   return <div style={{ display: active ? 'contents' : 'none' }}>{children}</div>;
}

ActivityCompat.propTypes = {
   active: PropTypes.bool.isRequired,
   children: PropTypes.node.isRequired,
};
